import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Modal, Form, Button, Col } from 'react-bootstrap';
import axios from 'axios';

import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext';
import { useResto } from '../contexts/RestoContext';

const LogoParameters = () => {
    const { t } = useTranslation();
    const { token } = useAuth();
    const { website, setIsLoading } = useWebsite();
    const [showLogoModal, setShowLogoModal] = useState(false);
    const [showFaviconModal, setShowFaviconModal] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [faviconFile, setFaviconFile] = useState(null);
    const { restoData } = useResto(); 
    const [logoUpdated, setLogoUpdated] = useState(false); 
    const [faviconUpdated, setFaviconUpdated] = useState(false); 

    const handleFileChange = (event, setter) => {
        setter(event.target.files[0]);
    };

    const handleEditSubmit = async (formData, endpoint) => {
        setIsLoading(true);

        try {
            const response = await axios.post(`${config.apiUrl}${endpoint}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            });
            if (endpoint === 'logo' && response.status === 204) {
                setLogoUpdated(true);
            }
            if (endpoint === 'favicon' && response.status === 204) {
                setFaviconUpdated(true);
            }
            handleCloseModal();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }

        setIsLoading(false);
    };

    const handleShowLogoModal = () => {
        setShowLogoModal(true);
    };

    const handleShowFaviconModal = () => {
        setShowFaviconModal(true);
    };

    const handleCloseModal = () => {
        setShowLogoModal(false);
        setShowFaviconModal(false);
    };

    return (
        <>
            <h2>Le logo & le favicon</h2>

            <div className="kubuni-frame">
                <Row>
                    <Col md={6}>
                        <div className="text-center">
                            {((restoData && restoData.hasLogo) || logoUpdated) ? (
                                <img src={`${config.documentsUrl}logos/logo_resized.png?${new Date().getTime()}`} alt="Logo" height="140" />
                            ) : (
                                <img 
                                    src={`${config.kubuniImagesUrl}mon-petit-resto/logos/logo_resized.png?${new Date().getTime()}`} 
                                    alt="Logo" 
                                    height="140" 
                                />
                            )}
                            <div>
                                <Button variant="primary" onClick={handleShowLogoModal} style={{ margin: '10px' }}>
                                    Mettre à jour le logo
                                </Button>
                            </div>
                        </div>

                    </Col>
                    <Col md={6}>
                        <div className="text-center">
                            {((restoData && restoData.hasFavicon) || faviconUpdated) ? (
                                <img src={`${config.documentsUrl}logos/favicon.png?${new Date().getTime()}`} 
                                     alt="Favicon" 
                                     height="64" 
                                     style={{margin:'38px'}} />
                            ) : (
                                <img
                                    src={`${config.kubuniImagesUrl}mon-petit-resto/logos/favicon.png?${new Date().getTime()}`}
                                    alt="Logo"
                                    height="64"
                                    style={{margin:'38px'}}
                                />
                            )}
                            
                            <div>
                                <Button variant="primary" onClick={handleShowFaviconModal} style={{ margin: '10px' }}>
                                    Mettre à jour le favicon
                                </Button>
                            </div>
                        </div>

                    </Col>
                </Row>
            </div>
            <div className="short-line"></div>

            <Modal show={showLogoModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Mettre à jour le logo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Logo (PNG uniquement)</Form.Label>
                            <Form.Control
                                type="file"
                                name="file"
                                onChange={(e) => handleFileChange(e, setLogoFile)}
                                accept=".png"
                                required
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Annuler
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => handleEditSubmit({ file: logoFile, website }, 'logo')}
                    >
                        Mettre à jour
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showFaviconModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Mettre à jour le favicon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Favicon (PNG uniquement)</Form.Label>
                            <Form.Control
                                type="file"
                                name="file"
                                onChange={(e) => handleFileChange(e, setFaviconFile)}
                                accept=".png"
                                required
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Annuler
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => handleEditSubmit({ file: faviconFile, website }, 'favicon')}
                    >
                        Mettre à jour
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default LogoParameters;
